import { takeLatest } from 'redux-saga/effects';

import { API_REQ_ACTION_TYPES } from 'api/actions';
import fileUploadSuccess from 'store/printRender/sagas/fileUploadSuccess';

import {
  createVersionFailure,
  exportProcess,
  getInstancesListError,
  handleErrorGetInstancesById,
  handleErrorSearch,
  importProcessFailure,
  importProcessSuccess,
  redirectToProcessDetails,
  reFetchList,
  reFetchProcessDetails,
} from './sagas';

// TODO: MOVE SAGA TO ITS OWN ENTITY
function* watchersSaga() {
  yield takeLatest(
    [API_REQ_ACTION_TYPES.PROCESSES.CREATE.SUCCESS],
    reFetchList
  );

  yield takeLatest(
    API_REQ_ACTION_TYPES.INSTANCE.FINISH_INSTANCE.SUCCESS,
    redirectToProcessDetails
  );

  yield takeLatest(
    [API_REQ_ACTION_TYPES.PROCESSES.SEARCH_BY_ID.ERROR],
    handleErrorSearch
  );

  yield takeLatest(
    [API_REQ_ACTION_TYPES.PROCESSES.GET_BY_ID.ERROR],
    handleErrorGetInstancesById
  );

  yield takeLatest(
    [
      API_REQ_ACTION_TYPES.PROCESSES.UPDATE_BY_ID.SUCCESS,
      API_REQ_ACTION_TYPES.PROCESSES.DEACTIVATE.SUCCESS,
      API_REQ_ACTION_TYPES.PROCESSES.IMPORT_IN.SUCCESS,
    ],
    reFetchProcessDetails // get latest release
  );

  yield takeLatest(
    [API_REQ_ACTION_TYPES.INSTANCE.GET_INSTANCE_BY_ID.ERROR],
    getInstancesListError
  );

  yield takeLatest(
    API_REQ_ACTION_TYPES.PROCESSES.EXPORT.SUCCESS,
    exportProcess
  );

  yield takeLatest(
    API_REQ_ACTION_TYPES.PROCESSES.IMPORT.SUCCESS,
    importProcessSuccess
  );

  yield takeLatest(
    [
      API_REQ_ACTION_TYPES.PROCESSES.IMPORT.ERROR,
      API_REQ_ACTION_TYPES.PROCESSES.IMPORT_IN.ERROR,
    ],
    importProcessFailure
  );

  yield takeLatest(
    API_REQ_ACTION_TYPES.INSTANCE.UPDATE_FILE_FIELD_VALUE.SUCCESS,
    fileUploadSuccess
  );

  yield takeLatest(
    API_REQ_ACTION_TYPES.PROCESSES.VERSIONS.CREATE.ERROR,
    createVersionFailure
  );
}

export default watchersSaga;
